<script setup lang="ts">
import type { Composer } from "vue-i18n";

const props = defineProps<{
  i18n: Composer;
  email: string;
}>();
</script>

<template>
  <i18n-t :i18n="props.i18n" tag="span" keypath="le-error-results.user-not-activated.activation-sent">
    <template #email>
      <span class="le-activation-mail-sent__email">{{ email }}</span>
    </template>
  </i18n-t>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-activation-mail-sent__email {
  padding: 0 4px;
  border-radius: 2px;
  background: @colors[@accent][200];
  color: @colors[@neutrals][500];
  font-weight: 600;
  word-break: break-word;
  hyphens: auto;
}
</style>
